import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';
import { motion } from 'framer-motion';
import { cn } from '../../utils/cn';

const ContactInfo = () => {
  const contactDetails = [
    {
      icon: Mail,
      title: 'Email',
      content: 'info@thirtyfivestudio.com',
      href: 'mailto:info@thirtyfivestudio.com'
    },
    {
      icon: Phone,
      title: 'Phone',
      content: '+1 (651) 219-8788',
      href: 'tel:+16512198788'
    },
    {
      icon: MapPin,
      title: 'Service Areas',
      content: 'Twin Cities, Rochester, MN'
    }
  ];

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className={cn(
        "relative p-8 rounded-3xl",
        "bg-[#111111]",
        "backdrop-blur-sm border border-primary-500/20",
        "hover:border-primary-500/40 transition-all duration-500",
        "shadow-lg shadow-primary-900/20",
        "hover:shadow-xl hover:shadow-primary-900/30",
        "group"
      )}
    >
      {/* Enhanced background glow effect */}
      <div className="absolute inset-0 bg-gradient-to-br from-primary-500/5 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-all duration-500 rounded-3xl" />
      
      <h3 className="text-2xl font-bold text-white mb-8">Contact Information</h3>
      
      <div className="space-y-8">
        {contactDetails.map((item, index) => (
          <div key={index}>
            <div className="flex items-center text-primary-400 mb-2">
              <item.icon className="w-5 h-5 mr-2" />
              <span>{item.title}</span>
            </div>
            {item.href ? (
              <a 
                href={item.href}
                className={cn(
                  "text-lg text-gray-300",
                  "hover:text-primary-400",
                  "transition-colors duration-300"
                )}
              >
                {item.content}
              </a>
            ) : (
              <p className="text-lg text-gray-300">{item.content}</p>
            )}
          </div>
        ))}
      </div>

      <div className="mt-12 p-8 bg-primary-500/10 rounded-2xl border border-primary-500/20">
        <h3 className="text-xl font-bold text-white mb-4">Ready to Get Started?</h3>
        <p className="text-gray-300 mb-6">
          Let's discuss how we can help transform your digital presence and drive growth for your business.
        </p>
        <motion.button
          onClick={() => window.open('https://calendly.com/thirtyfivestudio', '_blank')}
          className={cn(
            "px-8 py-4 rounded-full",
            "bg-primary-500 text-white",
            "hover:bg-primary-600",
            "transition-all duration-300",
            "transform hover:translate-y-[-2px]",
            "shadow-lg shadow-primary-900/20",
            "hover:shadow-xl hover:shadow-primary-900/30",
            "relative overflow-hidden group"
          )}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          {/* Button glow effect */}
          <div className="absolute inset-0 bg-gradient-to-r from-primary-400/0 via-primary-400/30 to-primary-400/0 -z-10 translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-1000" />
          
          Schedule a Call
        </motion.button>
      </div>
      
      {/* Corner indicators */}
      <div className="absolute top-4 right-4 w-2 h-2 rounded-full bg-primary-400/30 opacity-0 group-hover:opacity-100 transition-all duration-300" />
      <div className="absolute bottom-4 left-4 w-2 h-2 rounded-full bg-primary-400/30 opacity-0 group-hover:opacity-100 transition-all duration-300" />
    </motion.div>
  );
};

export default ContactInfo;